import { render } from "./FormPopup.vue?vue&type=template&id=178b336c"
import script from "./FormPopup.vue?vue&type=script&lang=js"
export * from "./FormPopup.vue?vue&type=script&lang=js"

import "./FormPopup.vue?vue&type=style&index=0&id=178b336c&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__